import { boolean, object, string } from 'yup';

const schema = object().shape({
  selectPeriod: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Bu xana zəruridir'),
  fileType: object()
    .shape({
      label: string(),
      value: string(),
    })
    .strict()
    .required('Bu xana zəruridir'),
  showEmail: boolean(),
  email: string().when('showEmail', {
    is: true,
    then: (schemaThen) =>
      schemaThen
        .required('Bu xana zəruridir')
        .email('E-mail düzgün deyil')
        .matches(
          /^[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
          'E-mail düzgün deyil'
        ),
  }),
  periodicity: string().when('showEmail', {
    is: true,
    then: (schemaThen) => schemaThen.required('Məlumatlardan birinin seçilməsi zəruridir'),
  }),
  startDate: string().when('selectPeriod.value', {
    is: '-1',
    then: (schemaThen) => schemaThen.required('Bu xana zəruridir'),
  }),
  endDate: string().when('selectPeriod.value', {
    is: '-1',
    then: (schemaThen) => schemaThen.required('Bu xana zəruridir'),
  }),
});

export default schema;
